export class User {
  public id: string;
  public email: string;
  public createdAt: Date;
  public creditLimit: number;
  public creditsUsed: number;

  constructor(obj: any) {
    this.id = obj.id;
    this.email = obj.email;
    this.createdAt = new Date(obj.createdAt);
    this.creditLimit = obj.creditLimit;
    this.creditsUsed = obj.creditsUsed;
  }
}
